import { RequestParams, ResponseCatalog } from 'Models'
import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { AgreementModel, ChangeAgreementRequestParams } from 'Pages/admin'

export const agreementApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<AgreementModel>>(urls.agreement.index, {
			params,
		})
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<AgreementModel>(
			urls.agreement.description.replace(':id', id.toString())
		)
		return res.data
	},
	getOneByKey: async (parentType: string, kind = '') => {
		const res = await axiosDS().get<AgreementModel>(
			urls.agreement.by_key.replace(':parent_type', parentType).replace(':kind', kind)
		)
		return res.data
	},
	updateOne: async (agreementInfo: { id: number; data: ChangeAgreementRequestParams }) => {
		const { id, data } = agreementInfo
		const res = await axiosDS().patch<AgreementModel>(
			urls.agreement.description.replace(':id', id.toString()),
			{
				data,
			}
		)
		return res.data
	},
	updateOneVersion: async (data: ChangeAgreementRequestParams) => {
		const res = await axiosDS().post<AgreementModel>(urls.agreement.index, {
			data,
		})
		return res.data
	},
}
